import { defineComponent as _defineComponent } from 'vue'
import { LANG_TRANS } from '@/domains/translation/constants';
import { useTranslationStates } from '@/composables/use-translation-states';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideViewSelfTranslationToggle',
  props: {
    value: { type: Boolean },
    side: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'change', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
    side: 'left' | 'right';
}





const { currentLanguageModes, currentTranslateLanguages } = useTranslationStates();

const transLang = computed(() => {
    return currentTranslateLanguages.value[props.side || 'left'];
});

const transLangType = computed(() => {
    return currentLanguageModes.value[props.side || 'left'];
});

function toggleStatus(value: boolean) {
    if (value === props.value) return;
    emit('change', value);
}

return { __sfc: true,props, emit, currentLanguageModes, currentTranslateLanguages, transLang, transLangType, toggleStatus, LANG_TRANS }
}

})